
<style scoped lang="less">
  .main{
    width:100%;
    height: 100%;
  }
  .top_title{
    width: 100%;
    height: 3.5rem;
    background-color: rgb(6,160,156);
    border-bottom-right-radius: 50px;
    border-bottom-left-radius: 50px;
    text-align: center;
    box-sizing: border-box;
    color: #fff;
    font-size: 18px;
    line-height: 3.5rem;
    position: relative;
    .fanhui{
        position: absolute;
        left: 2rem;
        top: 50%;
        margin-top: 3px;
        transform:translateY(-50%)
    }
  }
    /deep/.van-tabs{
        height: calc(100% - 6.8rem);
        width:100%;
    }
    /deep/.van-tabs__content{
        height:calc(100% - 2.7rem);
        width:100%;
        overflow-y: scroll;
    }
    /deep/.van-tab__pane{
        width:100%;
        // padding:0px 5%;
    }
    /deep/.van-tabs__line{
        width: 25%;
    }
    /deep/.van-tab--active{
        font-weight: bold;
    }
    /deep/.van-tab:nth-child(1).van-tab--active{
        color:rgb(6,160,156);
    }
    /deep/.van-tab:nth-child(2).van-tab--active{
        color:rgb(34,140,200);
    }
    /deep/.van-tab:nth-child(3).van-tab--active{
        color:rgb(243,28,109);
    }
    /deep/.van-tab:nth-child(4).van-tab--active{
        color:rgb(114,14,186);
    }
    /deep/.van-tab:nth-child(1).van-tab--active ~ .van-tabs__line{
        background-color: rgb(6,160,156);
    }
    /deep/.van-tab:nth-child(2).van-tab--active ~ .van-tabs__line{
        background-color: rgb(34,140,200);
    }
    /deep/.van-tab:nth-child(3).van-tab--active ~ .van-tabs__line{
        background-color: rgb(243,28,109);
    }
    /deep/.van-tab:nth-child(4).van-tab--active ~ .van-tabs__line{
        background-color: rgb(114,14,186);
    }
</style>
<style scoped>
    >>>.van-tabs{
        height: calc(100% - 6.8rem);
        width:100%;
    }
    >>>.van-tabs__content{
        height:calc(100% - 2.7rem);
        width:100%;
        overflow-y: scroll;
    }
    >>>.van-tab__pane{
        width:100%;
    }
    >>>.van-tabs__line{
        width: 25%;
    }
    >>>.van-tab--active{
        font-weight: bold;
    }
    >>>.van-tab:nth-child(1).van-tab--active{
        color:rgb(6,160,156);
    }
    >>>.van-tab:nth-child(2).van-tab--active{
        color:rgb(34,140,200);
    }
    >>>.van-tab:nth-child(3).van-tab--active{
        color:rgb(243,28,109);
    }
    >>>.van-tab:nth-child(4).van-tab--active{
        color:rgb(114,14,186);
    }
    >>>.van-tab:nth-child(1).van-tab--active ~ .van-tabs__line{
        background-color: rgb(6,160,156);
    }
    >>>.van-tab:nth-child(2).van-tab--active ~ .van-tabs__line{
        background-color: rgb(34,140,200);
    }
    >>>.van-tab:nth-child(3).van-tab--active ~ .van-tabs__line{
        background-color: rgb(243,28,109);
    }
    >>>.van-tab:nth-child(4).van-tab--active ~ .van-tabs__line{
        background-color: rgb(114,14,186);
    }
</style>

<template>
  <div class="main">
    <div class="top_title">
        <span class="fanhui" @click="getBack">
            <van-icon name="arrow-left" />
        </span>
      未来已来 不"溶"错过
    </div>
    <meSearch :searchVal="searchVal" @onSearch="onSearch" placeholder="搜索你想要的内容"></meSearch>
    <van-tabs v-model="activeItem" :before-change="onClickTabs">
        <van-tab title="前沿资讯">
            <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
            >
                <list :listData="listData"></list>
            </van-list>
        </van-tab>
        <van-tab title="直播间">
            <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
            >
                <video-list :listData="listData"></video-list>
            </van-list>
        </van-tab>
        <van-tab title="科研成果">
            <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
            >
                <list :listData="listData"></list>
                <!-- <graceful-list :listData="listData"></graceful-list> -->
            </van-list>
        </van-tab>
        <van-tab title="见证实“例”">
            <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
            >
                <instance-list :listData="listData"></instance-list>
            </van-list>
        </van-tab>
    </van-tabs>
    <van-popup v-model="showPopup" @close="onClose" :style="{ width: '80%' , borderRadius: '10%'}">
      <img src="../assets/image/homePage/jsz.png" width="100%">
    </van-popup>
  </div>
</template>
<script>
import list from '@/comm/list.vue'
import meSearch from '@/comm/meSearch.vue'
import videoList from '@/comm/videoList.vue'
import instanceList from '@/comm/instanceList.vue'
import gracefulList from '@/comm/gracefulList.vue'
import allApi from "@/http/allApi.js"
import {Toast} from 'vant'
export default {
  name: "homePage",
  data() {
    return {
      showPopup:false,
      activeItem:0,
      searchVal:"",
      finished:false,
      loading:false,
      listData:[],
      type:1,
      page:1,
      activeHostiry:0,
    };
  },
  components: {
    list,
    meSearch,
    videoList,
    instanceList,
    gracefulList
  },
  methods:{
    getBack() {
      this.$router.go(-1)
    },
    onLoad(){
        this.getList();
        this.page+=1;
    },  
    onClose(){
       this.activeItem  =this.activeHostiry ;
        this.page = 1;
        this.finished=false;
        this.listData=[];
        this.getList();
    },
    onSearch(i){
        this.searchVal = i;
        this.page = 1;
        this.finished=false;
        this.loading=false;
        this.listData=[];
        // this.getList();
    },
    onClickTabs(name, title){
        let hos = this.type;
        if(name==0){
            this.type = 1;
        }
        if(name==1){
            this.type = 4;
        }
        if(name==2){
            this.type = 3;
        }
        if(name==3){
            this.type = 2;
        }
        allApi.getCates().then(res=>{
            res.data.data.forEach(el => {
                if(el.id == name+1){
                    if(el.status==0){
                        this.showPopup = true;
                        this.type= hos;
                        this.activeHostiry = this.activeItem;
                        this.activeItem = name;
                        this.finished=true;
                        this.listData = [];
                        return false;
                    }else{
                        this.activeItem = name;
                        this.page = 1;
                        this.finished=false;
                        this.loading=false;
                        // this.searchVal = "";
                        this.listData=[];
                        this.getList();
                    }
                }
            });
        })
        this.listData=[];
    },
    getList(){
        Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: '加载中...',
        });
        allApi.getSearch({
            keyword:this.searchVal,
            type:this.type,
            page:this.page
        }).then(res=>{
            res.data.data.forEach(element => {
                let ifs = true;
                this.listData.forEach(el => {
                    if(el.id == element.id){
                        ifs= false;
                    }
                });
                if(ifs){
                    this.listData.push(element)
                }
            });
            if(res.data.data.length<10){
                this.finished = true;
            }
            Toast.clear();
            this.loading = false;
        })
    }
  },
  activated(){
        this.searchVal = "";
        this.page = 1;
        this.finished=false;
        this.loading=false;
        this.listData=[];
        this.getList();
  },
  mounted(){
    allApi.getShare().then(res=>{
      shareCommon(res.data.data.title,res.data.data.desc,res.data.data.img);
    })
  }
};


</script>
 
